import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { GenericModal } from "@Shared/components/modals";
import FollowUpTab from "../../../../../board/client-profile/components/actions-panel/follow-up-tab.vue";
import NoteTab from "../../../../../board/client-profile/components/actions-panel/note-tab.vue";
import EmailTab from "../../../../../board/client-profile/components/actions-panel/email-tab.vue";
import ChecklistTab from "../../../../../board/client-profile/components/actions-panel/checklist-tab.vue";
import ClientProfileDropdown from "./client-profile-dropdown.vue";
import DefaultBodyLoader from "@Shared/components/modals/generic-modal-loaders/default-body-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileQuickActionsModal",
  components: {
    GenericModal,
    FollowUpTab,
    NoteTab,
    EmailTab,
    ChecklistTab,
    ClientProfileDropdown,
    DefaultBodyLoader
  },
  props: {
    loadingProfile: {
      type: Boolean,
      default: false
    },
    linkedClientProfile: {
      type: Object,
      required: true
    },
    clientProfiles: {
      type: Array,
      required: true
    },
    quickActionName: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("BoardStore", {
    boards(state) {
      return state.boards.byId;
    },
    profileData(state) {
      return state.clientProfiles.byId[this.clientProfileId] || {};
    }
  })), {}, {
    clientProfileId() {
      return this.linkedClientProfile.clientProfileId;
    }
  }),
  methods: {
    handleHidden() {
      this.$emit("hidden");
    },
    handleItemAdd() {
      this.$refs.modal.hide();
    },
    getQuickActionComponent() {
      const componentNameMap = {
        activity: FollowUpTab,
        note: NoteTab,
        email: EmailTab,
        checklist: ChecklistTab
      };
      return componentNameMap[this.quickActionName];
    },
    handleSelectedProfile(clientProfileId) {
      this.$emit("select", clientProfileId);
    }
  }
});